export interface IToken {
  token: string;
  issued: number;
  expires: number;
}

export interface IUser {
  uuid: string;
  dateCreated?: number;
  email: string;
  isEmailConfirmed?: boolean;
  emailPending: string | null;
  role?: UserRole;
  lastImageUpdateUnixTimestamp: number;
  isPasswordSet: boolean;
}

export const enum UserRole {
  admin = "admin",
  common = "common",
  collector = "collector",
  premium = "premium",
  guest = "guest"
}

export interface ResourceLimits {
  albumCount: number;
  limitAlbums: number;
  artistCount: number;
  limitArtists: number;
  labelCount: number;
  limitLabels: number;
  storeCount: number;
  limitStores: number;
  albumFormatCount: number;
  limitAlbumFormats: number;
  albumTypeCount: number;
  limitAlbumTypes: number;
  sellValueCount: number;
  limitSellValues: number;
  exchangeRateCount: number;
  limitExchangeRates: number;
  collectionCount: number;
  limitCollections: number;
  shelvingCount: number;
  limitShelvings: number;
  tagCount: number;
  limitTags: number;
}
